import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { TokenStorageService } from 'src/app/core/security/token-storage-service';

declare var $: any;

@Component({
  selector: 'geolocation-selector',
  templateUrl: './geolocation-selector.component.html',
  styleUrls: ['./geolocation-selector.component.scss']
})
export class GeolocationSelectorComponent implements OnInit {

  @Input() collectionName;
  @Input() geoPrivilegeSelectorCreate: boolean;
  @Input() geoPrivilegeSelectorUpdate: boolean;
  @Input() locationType: string;
  @Output() updateCollection = new EventEmitter();
  @Output() updateGeoPrivilegeSelected = new EventEmitter();

  private collection;
  private select;
  public orderUrl = environment.runtime.hubconnectPortalUrl;
  private id;
  private idSubscriber;

  constructor(private elementRef: ElementRef,
    public customerService: CustomerService,
    private storageService: TokenStorageService) { }

  async ngOnInit() {
    this.idSubscriber = await this.customerService.currentCustomerID$.subscribe(data => {
      this.id = data;
    })
    let parentElement = '';
    if (this.geoPrivilegeSelectorCreate) {
      this.collection = this.customerService.newCustomerUser[this.collectionName];
      parentElement = $(".locations-container");
    } else if (this.geoPrivilegeSelectorUpdate) {
      this.collection = this.customerService.updatedCustomerUser[this.collectionName];
      parentElement = $(".content-body");
    }
    let token = await this.storageService.getAccessToken();
    let that = this;
    this.select = $(this.elementRef.nativeElement).find('.filter-locations').select2({
      width: '100%',
      ajax: {
        url: () => { return `${that.orderUrl}/hubconnectapi/orders/autocomplete?id=${that.id}` },
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        },
        datatype: 'json',
        delay: 250,
        data: function (params: any) {
          return {
            q: `${params.term.trim()}~${that.locationType}`
          };
        },
        processResults: function (data: any) {
          let res = []
          data.zip_code.map((item) => {
            res.push({
              id: [
                item,
                "",
                "zip_code"
              ],
              text: item
            })
          });
          data.state.map((item) => {
            res.push({
              id: [
                item,
                "",
                "state"
              ],
              text: item
            })
          });
          data.city_state.map((item) => {
            res.push({
              id: [
                item,
                "city_state"
              ],
              text: item
            })
          });
          data.name.map((item) => {
            res.push({
              id: [
                item,
                "",
                "name"
              ],
              text: item
            })
          });
          return {
            results: res
          }
        },
        cache: true
      },
      placeholder: 'Add a city, state, zip, or location',
      minimumInputLength: 2,

      // for FastClick, displays the selectable list
      templateResult: function (result, container) {
        if (!result.id) {
          return result.text;
        }
        container.className += ' needsclick';
        return result.text;
      },
      dropdownParent: parentElement
    });

    if (this.geoPrivilegeSelectorUpdate || this.geoPrivilegeSelectorCreate) {
      this.select.on('change', () => {
        this.updateGeoPrivilegeSelected.emit(this.select.val());
      });
    }

    // load in filters previously selected in the current session
    if (this.collection && this.collection.length) {
      for (var i = 0, len = this.collection.length; i < len; i++) {
        // If re-editing while creating a new user, location doesn't have proper structure, reformat...
        if (!this.collection[i].id) {
          let parts = this.collection[i].split(",")
          this.collection[i] = {
            text: parts[0]
          }
          if (parts[1]) {
            parts[0] += "," + parts[1]
            this.collection[i].id = [parts[0], parts[2]]
            this.collection[i].text = parts[0]
          }
          else {
            this.collection[i].id = [parts[0], parts[1], parts[2]]
          }
        }
        var $persistedSelectedOption = $('<option selected></option>').val(this.collection[i].id).text(this.collection[i].text);
        this.select.append($persistedSelectedOption).trigger('change');
      }
    }

    // to remove the auto complete option that browsers have.
    let elements = document.getElementsByClassName("select2-search__field");

    for (let i = elements.length - 1; i >= 0; i--) {
      elements.item(i).setAttribute('autocomplete', '--no---autofill--field--');
    };
  }

  ngOnDestroy() {
    this.idSubscriber.unsubscribe();
    this.select.select2('destroy');
  }
}

